import {
  DBxEvent
} from "cartovista";
import ResultsList from "../Results/ResultsList";
import ServiceAreasResultItem from "./ServiceAreasResultItem";

    export default class ServiceAreasResultsList extends ResultsList {
      constructor($container, layer, dataTable, accordion) {
        super($container, layer, dataTable, accordion);
      };

    addResult(features, name) {
        this.increment += 1;
        this.resultItems.push(new ServiceAreasResultItem(this, features, name));
        this.generateUI();
        this.dispatchEvent(new DBxEvent("ResultsList_resultAdded"));
    };
}
